<template>
<div>
<v-autocomplete
  :items="cities"
  :filter="customFilter"
  :attach="true"
  v-model="currentCity"
  color="white"
  item-text="name"
  placeholder="Start typing to Search"
  label="City"
  chips
  return-object
></v-autocomplete>


  </div>
</template>

<script>
  export default {
    data: () => ({
      descriptionLimit: 60,
      isLoading: false,
      currentCity: { name: 'Stuttgart', lat: 48.7738149, lng: 9.1731858 },
      cities: [
          { name: 'Stuttgart', lat: 48.7738149, lng: 9.1731858 },
          { name: 'Hamburg', lat: 53.5503866, lng: 9.9901746 },
          { name: 'München', lat: 48.1580384, lng: 11.5357464 },
          { name: 'Berlin', lat: 52.5015598, lng: 13.3588464 },
          { name: 'Düsseldorf', lat: 51.2206442, lng: 6.7570033 },
          { name: 'Köln', lat: 50.9381637, lng: 6.9568145 },
          { name: 'Frankfurt', lat: 50.1251403, lng: 8.6634339 },
        ],
    }),

    computed: {
    },

    watch: {
      currentCity: function(val) {
          this.$emit('childToParent', this.currentCity)

      },
    },
    methods: {
      customFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1
      },
      emitToParent (event) {
        this.$emit('childToParent', this.currentCity)
      }
    },
    created(){
      this.$emit('childToParent', this.currentCity)
    }
  }
</script>
